import { Component } from "@angular/core";

import { BlackButtonComponent } from "../../../shared/components/black-button/black-button.component";
import { SliderComponent } from "../../../shared/slider/slider.component";

@Component({
  selector: "app-success",
  standalone: true,
  imports: [SliderComponent, BlackButtonComponent],
  templateUrl: "./success.component.html",
  styleUrl: "./success.component.scss",
})
export class SuccessComponent {}
